import { render } from "./TableStructureDemo.vue?vue&type=template&id=63d9892e&scoped=true"
import script from "./TableStructureDemo.vue?vue&type=script&lang=js"
export * from "./TableStructureDemo.vue?vue&type=script&lang=js"

import "./TableStructureDemo.vue?vue&type=style&index=0&id=63d9892e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d9892e"]])

export default __exports__